// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_CriarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/links/criar
 *
 * Returns the created payment link record. The controller fetches it back via
 * Payment_links_model::getById($link_id) — a plain `SELECT * FROM payment_links`
 * cast to array — so the dados shape mirrors the `payment_links` table exactly.
 *
 * Numeric columns (id, owner_id, subaccount_id, amount, installments,
 * paid_amount, notification_count) arrive as MySQL strings and are coerced to
 * int below. Date/datetime columns are NOT timezone-converted on this path —
 * they pass through as raw GMT-3 MySQL strings (or null).
 *
 * Source columns: see Payment_links_record metadata in
 * models/payment_links/payment_links_model.php and the homologacao
 * `payment_links` table.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsLinks_CriarResponseDados {
id: number
owner: string
owner_id: number
subaccount_id: number
creator_user_id: string
provider_code: string
amount: number
payment_method: string
charge_type: string
installments: number
status: string
notification_count: number
provider_link_id?: string
url?: string
due_date?: string
description?: string
paid_at?: string
paid_amount?: number
last_notification_sent_at?: string
created_at?: string
updated_at?: string
cancelled_at?: string
cancelled_by_user_id?: string
cancellation_reason?: string
}

export type SubaccountsLinks_CriarResponse = ApiResponse<SubaccountsLinks_CriarResponseDados>;

registerResponseContract('SubaccountsLinks_CriarResponse', {
  id:                        { type: 'number',  required: true },
  owner:                     { type: 'string',  required: true },
  owner_id:                  { type: 'number',  required: true },
  subaccount_id:             { type: 'number',  required: true },
  creator_user_id:           { type: 'string',  required: true },
  provider_code:             { type: 'string',  required: true },
  amount:                    { type: 'number',  required: true },
  payment_method:            { type: 'string',  required: true },
  charge_type:               { type: 'string',  required: true },
  installments:              { type: 'number',  required: true },
  status:                    { type: 'string',  required: true },
  notification_count:        { type: 'number',  required: true },
  provider_link_id:          { type: 'string',  required: false },
  url:                       { type: 'string',  required: false },
  due_date:                  { type: 'string',  required: false },
  description:               { type: 'string',  required: false },
  paid_at:                   { type: 'string',  required: false },
  paid_amount:               { type: 'number',  required: false },
  last_notification_sent_at: { type: 'string',  required: false },
  created_at:                { type: 'string',  required: false },
  updated_at:                { type: 'string',  required: false },
  cancelled_at:              { type: 'string',  required: false },
  cancelled_by_user_id:      { type: 'string',  required: false },
  cancellation_reason:       { type: 'string',  required: false },
})
